export const URL = 'info/opinion';
export const URL_ALL = 'info/shareholder';
export const URL_INVITE_SPEAK = 'opinion/speak';
export const URL_SEND_BOSS = 'opinion/send-boss';
export const URL_DISPLAY = 'opinion/public';

export const GET_LIST = 'GET_SECRETARY_COMMENT_LIST_LIST';
export const SET_CHOOSE_LIST = 'SET_SECRETARY_COMMENT_LIST_LIST';
export const SET_FILTER = 'SET_SECRETARY_COMMENT_LIST_FILTER';
export const SET_TOTAL = 'SET_SECRETARY_COMMENT_LIST_TOTAL';
export const GET_TOGGLE_MODAL = 'SET_SECRETARY_COMMENT_TOGGLE_MODAL';
